import { ParsedUrlQuery } from 'node:querystring';

import { GetServerSideProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import urls from '@/constants/url';
import PageSingle from '@/features/page';
import { Page } from '@/features/page/types';
import { textVariableReplacer } from '@/helpers/common';
import serverSideFetch from '@/utils/fetch';

type Params = ParsedUrlQuery & {
  path: string[];
};

type Props = {
  data?: Page;
  pageTitle?: string;
};
const DynamicContent: NextPage<Props> = ({ data }) => (data ? <PageSingle {...data} /> : null);

export const getServerSideProps: GetServerSideProps<Props, Params> = async ({ params, req, locale }) => {
  const path = `/${(params?.path ?? []).join('/')}`;

  if (!new RegExp('^[^.]+$').test(path) || path === '/404') {
    return {
      props: {}
    };
  }

  const pageData = await serverSideFetch<Page | null>(
    req,
    textVariableReplacer(urls.content.aliasContent, { path }),
    {}
  );

  if (!pageData) {
    return {
      redirect: {
        statusCode: 302,
        destination: '/404'
      }
    };
  }

  return {
    props: {
      data: pageData,
      pageTitle: pageData.title,
      ...(await serverSideTranslations(locale || 'en', ['public']))
    }
  };
};

export default DynamicContent;
